<template>
    <section id="_caonima" :class="[shit$(`c:#fff;`)]">
        <template v-if="folderList">
            <!-- mxw:1380px; -->
            <div :class="shit$(`h:100%;  margin:auto;`)">
                <T-add @addEventProxy="addEventProxy" :class="[shit$(`font:14px; dis:i-b; radius:18.5px;`)]" />
                <T-header :mode="0" ref="headerRef$" @getClickMsg="msg => (clearTableSortState(), handleHeaderData(msg))"
                    :info="headerData" :class="[ shit$(`mt:21px; font:18px; letter-s:1.29px; w:76%;`) ]" />
                <div :class="[shit$(`mt:6px; dis:f; h:calc(100% - 89.3px); justify-c:sb;`)]">
                    <T-table :scrollLoadState="scrollLoadState" @proxyloadScroll="proxyloadScroll" :class="shit$(`w:76%;`)" ref="tableRef$" 
                    :header="headerData" 
                    :data="folderList" 
                    @getCurrentDbClickTableRowId="msg =>
                        (isHeaderPathChangeT(headerData, { query: msg }, 'path') && clearTableSortState(), handlePreviewData(msg))" 
                      @handleHeaderDataProxy="item => handleHeaderData(item)" @tableToolhandle="handleTableRUD" @getCurrentClickTableRowId="updatedPreviewData" />
                    <T-preview v-if="showPreview" :data="previewData" :class="[shit$(`mxw:23%; ml:15px; w:23%;`)]" />
                </div>
            </div>
        </template>
        <T-dialog 
        ref="dialog"
        @handleHeaderDataProxy="item => handleHeaderData(item)"
        :folderListD="folderList" 
        :headerDataD="headerData" 
        :data="dialogData" 
        :options="dialogOptions" 
        :currentWhereFolderOfTable="currentWhereFolder" />
        <dialog-notify />
        <export-excute :data="exportProjects" ref="exportExcute" @close="exportProjects = []"></export-excute>
    </section>
</template>

<script>
import TAdd from "@/code-lab/component/file-management/add.vue";
import THeader from "@/code-lab/component/file-management/header.vue";
import TTable from "@/code-lab/component/file-management/table.vue";
import TPreview from "@/code-lab/component/file-management/preview.vue";
import mixFileManagement from "@/code-lab/component/file-management/mixins/mix-file-request-manage.js"; 
import projectFolderCrud from "@/code-lab/component/file-management/mixins/project-folder-crud.js";
import mixTableDataCrud from "@/code-lab/component/file-management/mixins/mix-table-data-crud.js";
import MixTool from '@/code-lab/component/file-management/mixins/tool-mix.js'
import { mutations as menueMutations } from '@/code-lab/component/layout/control-menue/observable.js'
import exportExcute from "@/code-lab/component/file-management/export-excute/export-excute.vue";
import TDialog from "@/code-lab/component/file-management/dialog.vue";
import DialogNotify from '@/code-lab/component/file-management/dialog-notify/dialog-notify.vue'

import { mapState, mapActions } from 'vuex'
export default {
  mixins: [mixFileManagement, projectFolderCrud, mixTableDataCrud, MixTool],
  components: {
    "T-add": TAdd,
    "T-table": TTable,
    "T-header": THeader,
    "T-dialog": TDialog,
    "T-preview": TPreview,
    DialogNotify,
    exportExcute
  },
  data(){
    return {
      exportProjects: []
    }
  },
  computed: {
    ...mapState('notifySystem', ['isUpdateData'])
  },
  mounted () {
    this.get_folder_list$(this.responseDataCb)
  },
  methods: {
    ...mapActions("notifySystem", { newAct$: 'new' }),
    proxyloadScroll () {
      if(!this.lockScroll){
        console.log('proxyloadScroll')
        this.handleLoadFromScroll()
      }
    },
    clearTableSortState () {
      
      delete this.headerData[this.headerData.length - 1].query.sort
      
      this.$refs["tableRef$"] && this.$refs["tableRef$"].clearSortState()
    },
    importProject$ () { 
      this.$store.commit('notifySystem/currentWhereOfFolderList', { ...this.currentWhereFolder, pathNam$: this.headerData.map(m => m.label).join('/') })
      this.$store.commit('notifySystem/openFileHandle', true)
    },
    addEventProxy (item) {
      console.log(item, 'addEventProxy')
      const mp = { 1: "addProject$", 2: "addFolder$", 3: "importProject$" , 4: "cloneSample$"}
      const fn = mp[item.is]
      if (fn === 'addProject$' && this.currentVersion !== 'teacher') {
        const prams = { name: this.$t("code-lab/component/file-management/index.vue_0"), folderId: this.getArrayLastItem(this.headerData).query.folderId, ...this.getRequestQuery(this.currentWhereFolder) }
        this.add_project$(res => {
          if (res.status && Number(res.status.code) === 0) {
            const { projectId } = res.data
            const script = window.CONSTS.EMPTY_WORK_SPACE
            this.edit_project$(res => {
              if (res.status && Number(res.status.code) === 0) {
                this.reRequestUpdateIndex()
                
              }
            }, { projectId, script: window.nuwa.utils.base64.encode(script) })
          }
        }, prams)
        return
      }
      if(fn === "cloneSample$"){
        const folderId = this.getArrayLastItem(this.headerData).query.folderId;
        const currentWhereFolder = this.getRequestQuery(this.currentWhereFolder);
        this.clone_sample$(res => {
          if (res.status && Number(res.status.code) === 0) {
            this.move_project$ (res2 => {
              if(res2.status && res2.status.code === "0"){
                 this.reRequestUpdateIndex()
              } else {
                this.$message.error(this.$t("message.error_add_project"))
              }
            }, { folderId, projectIds: [ res.data.newProjectId ], ...currentWhereFolder })
          } else {
            this.$message.error(this.$t("message.error_add_project"))
          }
        }, item.params);
        return;
      }
      console.log(fn)
      fn && this[fn]()
    },
    handleTableRUD ({ item, rows }) {
      if(rows.length === 0){
        return;
      }
      const {funcName} = item;
      console.log("rows:", rows);
      this[funcName] && this[funcName](rows)
    },
    uploadProject$(data){
      if(data.length === 0){
        return;
      }
      this.$confirm(this.$t("upload.message_upload_project_rms"), this.$t("popper_title.upload_project_rms"), {
            dangerouslyUseHTMLString: true,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            cancelButtonClass: "export-pop-button gray",
            confirmButtonClass: "export-pop-button  blue",
            cancelButtonText: this.$t("button.cancel"),
            confirmButtonText: this.$t("button.ok"),
            customClass: "export-excute-popper",
      }).then(() => {
        console.log("upload project :", data);
        const requestId = this.util$.getRandomId$('upload_project');
        const failedNotify = (content) => {
          this.$store.commit("notifySystem/update",
              { id: requestId, 
                notify: { 
                  href: "static/svg/pop/filed.svg", 
                  svg: '#code-lab-import-failed-icon', 
                  progress: 100, 
                  title: this.$t("code-lab/view/organization/s-import.js_5"), 
                  content  
                }
            })
        }
        this.export_execute_file$(res => {
          console.log("upload project", res)
          if(res.data && res.data.state){
            if(res.data.state === "task_creating"){
              this.newAct$({   
                  id: requestId,
                  href: "static/svg/pop/loading.svg", 
                  svg: '#t-code-notify-manage-loading', 
                  progress: 0, 
                  title: this.$t("code-lab/view/organization/s-import.js_1"),
                  content: this.$t("upload.message_percent"),
                  hide: false
              })
            } else if(res.data.state === "task_created"){
              const randomPercent = parseInt(Math.random() * 20) + 40
              this.$store.commit("notifySystem/update",
              {   
                  id: requestId,
                  notify: { 
                    href: "static/svg/pop/loading.svg", 
                    svg: '#t-code-notify-manage-loading', 
                    progress: randomPercent, 
                    title: this.$t("code-lab/view/organization/s-import.js_1"),
                    content: this.$t("upload.message_percent"),
                    hide: false
                }
              })
            } else if(res.data.state === "task_finished"){
              this.$store.commit("notifySystem/update",
              {   
                  id: requestId,
                  notify: { 
                    href: "static/svg/pop/successful.svg", 
                    svg: '#code-lab-import-successful-icon', 
                    progress: 100, 
                    title: this.$t("code-lab/view/organization/s-import.js_3"),
                    content: this.$t("upload.message_upload_rms_success"),
                    hide: false
                }
              })
            } else if(res.data.state === "task_failed"){
                failedNotify(this.$t("請檢查網路狀態，並再試一次吧！"))
            }
          }  else {
            failedNotify(this.$t("請檢查網路狀態，並再試一次吧！"))
            }
        }, {
          projectId: data[0].projectId,
          isExportToRms: true
        })
      }).catch(() => {})
    },
    downloadProject$(data){
      const dialog = this.$refs.dialog;
      if(!dialog){
        return;
      }
      const {projectId} = data[0];
      dialog.exportProjectRequest$({projectId, key: 0}, url => {
        dialog.downloadToComputerT(url)
      })
    },
    exportProject$ (data) {
      this.exportProjects = data;
      this.$refs.exportExcute && (this.$refs.exportExcute.visible = true);
    },
    reRequestUpdateIndex () {
      this.handleHeaderData(this.getArrayLastItem(this.headerData))
    }
  },
  watch: {
      menueCurrent (newVal) {
        Object.assign(this, { folderList: [], subFolders: [] })
        Object.assign(this, { previewData: null })
        this.get_folder_list$(this.responseDataCb, { folderType: newVal }, newVal)
        this.clearTableSortState()
      },
      currentWhereFolder (newVal) {
        this.$store.commit('notifySystem/currentWhereOfFolderList', { ...newVal, pathNam$: this.headerData.map(m => m.label).join('/') })
        
      },
      isUpdateData (newVal) {
        if (newVal) {
          this.reRequestUpdateIndex()
          this.$store.commit("notifySystem/isUpdateData", false)
        }
      }
  },
  destroyed () {
    console.log('destroyed -> my')
    menueMutations.current('my')
  },
}
</script>

<style lang="scss">
.notifyCustomClass.right {
  right: 30px;
}
.notifyCustomClass {
  width: auto;
  color: red;
  padding: 17px 0px 24px 25px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
  background-color: #444444;
  border: none;
  .el-notification__closeBtn:hover {
    color: #fff;
    font-weight: 900;
  }
  .el-notification__group {
    margin-left: 50px;
    margin-right: 25px;
  }
  .el-notification__title {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    height: 24px;
    line-height: 24px;
  }
  .el-notification__content {
    font-size: 12px;
    max-width: 300px;
    font-weight: 500;
    color: #fff;
    margin-right: 25px;
    margin: 5px 0 0;
    line-height: 1.5;
  }
}
#_caonima {
  .el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 38px;
    line-height: 38px;
  }
  .el-table__header {
    border-top: 1px solid #696969;
  }
  .el-table {
    color: #c8c8c8;
    font-size: 12px;
    letter-spacing: 0.86px;
  }
  .el-table,
  .el-table__expanded-cell {
    background-color: transparent;
  }
  .el-table th,
  .el-table tr {
    background-color: transparent;
  }
  .el-table--enable-row-hover .el-table__body tr > td {
    height: 70px;
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(255, 255, 255, 0.2);
    color: #ffffff;
  }
  
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #696969;
  }
  .el-table::before {
    background-color: #696969;
  }
  .el-table__body-wrapper {
    
    height: calc(100% - 38px);
    .el-table__body {
      height: 100%;
      height: calc(100% - 1px);
      display: block;
      overflow-y: auto;
    }
  }
  tbody {
    overflow-y: auto;
    overflow-x: hidden;
  }
}
</style>
